import React, { useEffect, useState } from "react";
import SurveyRendererContainer from "../../../Shared/Surveys/renderer/SurveyRendererContainer";
import Text from "../../../components/Text";
import Messages from "../../../Shared/Messages";
import patientsService from "../../../services/patientsService";
import { Button } from "reactstrap";
import { CONTINUE_TEXT_W_LANG } from "../../../Common/Signup/IntroText";
import I18nProvider from "../../../services/I18nProvider";
import MPSButton from "../../../components/Buttons/Buttons/MPSButton";
const intl = I18nProvider.getIntlProvider();

const ExternalSurveySubmission = ({ patientId, surveyId }) => {
  const [submitted, setSubmitted] = useState(false);
  const [languageSelected, setLanguageSelected] = useState(null);
  const [locales, setLocales] = useState([]);

  const getLocales = () => {
    patientsService
      .loadArtifact(`/api/a/survey/?p=${patientId}&s=${surveyId}`)
      .then((survey) => {
        let supportedLocales;
        if (survey.supportedLocales && survey.supportedLocales.length > 0) {
          supportedLocales = survey.supportedLocales;
        } else {
          supportedLocales = ["en_US"];
        }
        setLocales(supportedLocales);
        if (supportedLocales.length === 1) {
          setLanguageSelected(supportedLocales[0]);
        }
      });
  };

  const PREFERRED_LANGUAGE_TEXT = {
    en_US: "Preferred Language",
    ar_AE: "اللغة المفضلة",
    es_ES: "Lengua preferida",
    es_LA: "Lengua preferida",
    fr_FR: "Langue préférée",
    pt_BR: "Idioma preferido",
    pt_PT: "Língua preferida",
    iw_IL: "שפה מועדפת",
  };

  useEffect(() => {
    getLocales();
  }, []);

  if (!submitted) {
    // Skip language selection if only one locale OR if language is already selected
    if (!languageSelected && locales.length > 1) {
      return (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "2rem",
            }}
          >
            <div className="d-flex justify-content-center mb-4">
              <img src="/img/logo-symbol.png" height={42} alt="myPatientSpace logo" />
            </div>

            <div>
              <div
                className="d-flex justify-content-start"
                style={{ margin: 40 }}
              >
                {locales.map((locale, index) => (
                  <span key={locale}>
                    <h4 style={{ display: "inline" }}>
                      {PREFERRED_LANGUAGE_TEXT[locale]}
                      {index < locales.length - 1 && (
                        <span style={{ margin: "0 0.5rem" }}>|</span>
                      )}
                    </h4>
                  </span>
                ))}
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "1rem",
                }}
              >
                {locales &&
                  locales.map((locale) => (
                    <MPSButton
                      key={locale}
                      onClick={() => {
                        setLanguageSelected(locale);
                      }}
                      style={{ padding: "0.5rem 1rem" }}
                    >
                      {CONTINUE_TEXT_W_LANG[locale]}
                    </MPSButton>
                  ))}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <SurveyRendererContainer
          artifactId={surveyId}
          patientId={patientId}
          onComplete={() => setSubmitted(true)}
          locale={languageSelected}
          external
          embedded
        />
      );
    }
  } else {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ marginTop: "80px" }}
      >
        <Text content={Messages.thanks_external_submission} />
      </div>
    );
  }
};

export default ExternalSurveySubmission;
